import { Component } from 'react';
import { connect } from 'react-redux';
import { errorActions } from '../../actions/error.actions';
import { routes } from '../../constants/routes';
import { logger } from '../../logging/logger';
import { history } from '../../history';
import { NotFound } from './NotFound';
import { Forbidden } from './Forbidden';
import { Internal } from './Internal';
import { AnonymousLayout, Layout as AuthenticatedLayout } from '../layouts';
import { user } from '../../user';
import { Logout } from '../account';

class Shield extends Component {
    componentDidCatch = error => this.props.dispatch(errorActions.criticalError(error));

    render = () => {
        const { criticalError, error = {} } = this.props.error;
        if (criticalError && !errorActions.isRequestCancelationError(error)) { // skip request cancelation errors
            logger.exception(error, 'Front-end critical error');

            const withLayout = component => {
                return user.isAuthenticated()
                    ? <AuthenticatedLayout isError={true}>{component}</AuthenticatedLayout>
                    : <AnonymousLayout>{component}</AnonymousLayout>
            }

            switch (+error.status) {
                case 401: return history.location.pathname === routes.login ? this.props.children : <Logout />;
                case 403: return withLayout(<Forbidden />);
                case 404: return withLayout(<NotFound />);
                default: return withLayout(<Internal />);
            }
        }

        return this.props.children;
    }
}

const mapStateToProps = ({ error }) => ({ error });

const connectedShield = connect(mapStateToProps)(Shield);

export { connectedShield as Shield };
